import React from 'react'
import JoinUs from './JoinUs'

export default function RegistrationChoice() {
    return (
        <div style={{ position: "absolute", top: "5.5vw", display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: 'fitContent', padding: "2vmax 0" }}>
            <JoinUs color="#d3e2ff" />
        </div>
    )
}
